import { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';

import { protectedResources } from '../utils/authConfig';
import {
  acquireTokenSilently,
  getAccountIdStorageKey,
} from '../utils/authProvider';
import * as logger from '../utils/logger';
import { isSharedPath } from '../utils/paths';

export const requestInterceptor = async (
  value: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const newConfig: InternalAxiosRequestConfig = { ...value };

  if (isSharedPath(window.location.pathname)) {
    return newConfig;
  }

  let accessToken = '';
  try {
    const tokenResult = await acquireTokenSilently(
      protectedResources.api.scopes
    );
    if (tokenResult) {
      accessToken = tokenResult.accessToken;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    logger.error(error);
  } finally {
    const storageKey = getAccountIdStorageKey();
    const accountId = storageKey ? localStorage.getItem(storageKey) : null;

    newConfig.headers = {
      ...value.headers,
      Authorization: `Bearer ${accessToken}`,
      ...(accountId ? { 'Account-Id': accountId } : {}),
    } as AxiosRequestHeaders;
  }
  return newConfig;
};
